import { QueryAPI } from "../api";

export const useCrm = () => {
	const querySPPurchasePerCustomerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/Subscription/QuerySPPurchasePerCustomerByState", parameters: parameters });
		return response ? response : null;
	};
	const querySPPurchaseByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/Subscription/QuerySPPurchaseByState", parameters: parameters });
		return response ? response : null;
	};

	const updateSPPurchaseFromPostToPrintDocState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/UpdateSPPurchaseFromPostToPrintDocState", parameters: parameters });
		return response ? response : null;
	};
	const querySPPurchasePrintDocState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/QuerySPPurchasePrintDocState", parameters: parameters });
		return response ? response : null;
	};
	const updateSPPurchaseFromPrintDocToPrintBarcodeState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/UpdateSPPurchaseFromPrintDocToPrintBarcodeState", parameters: parameters });
		return response ? response.Result : null;
	};
	const querySPPurchasePrintBarcodeState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/QuerySPPurchasePrintBarcodeState", parameters: parameters });
		return response ? response : null;
	};
	const updateSPPurchaseFromPrintBarcodeToFinalState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/UpdateSPPurchaseFromPrintBarcodeToFinalState", parameters: parameters });
		return response ? response.Result : null;
	};
	const querySPPurchasePrintBarcodeStateById = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/CRM/PostCartable/QuerySPPurchasePrintBarcodeStateById", parameters: parameters });
		return response ? response.Result : null;
	};
	return {
		querySPPurchasePerCustomerByState,
		updateSPPurchaseFromPostToPrintDocState,
		querySPPurchasePrintDocState,
		updateSPPurchaseFromPrintDocToPrintBarcodeState,
		querySPPurchasePrintBarcodeState,
		updateSPPurchaseFromPrintBarcodeToFinalState,
		querySPPurchasePrintBarcodeStateById,
		querySPPurchaseByState,
	};
};
